'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseClearableTextField = require('@bibliocommons/base-clearable-text-field');

var _baseClearableTextField2 = _interopRequireDefault(_baseClearableTextField);

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseIcons = require('@bibliocommons/base-icons');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

require('../styles/SearchBar.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchBar = function (_BcReactComponent) {
  _inherits(SearchBar, _BcReactComponent);

  function SearchBar(props) {
    _classCallCheck(this, SearchBar);

    var _this = _possibleConstructorReturn(this, (SearchBar.__proto__ || Object.getPrototypeOf(SearchBar)).call(this, props));

    _this.bindAll('handleQueryCleared', 'handleSubmit');
    return _this;
  }

  _createClass(SearchBar, [{
    key: 'handleQueryCleared',
    value: function handleQueryCleared() {
      this.props.handleChange('');
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      this.props.handleSearch();
    }
  }, {
    key: 'renderLabelText',
    value: function renderLabelText() {
      if (this.props.label) {
        return this.props.label;
      }

      return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_label_search_box' });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          handleSearch = _props.handleSearch,
          query = _props.query,
          handleChange = _props.handleChange,
          placeholder = _props.placeholder;

      return _react2.default.createElement(
        'div',
        { className: 'cp-user-list-search-bar', onSubmit: handleSearch },
        _react2.default.createElement(
          'label',
          { className: 'sr-only', id: 'search-bar-label', htmlFor: 'search-bar-query' },
          this.renderLabelText()
        ),
        _react2.default.createElement(_baseClearableTextField2.default, {
          id: 'search-bar-query',
          value: query,
          labelledById: 'search-bar-label',
          handleChange: handleChange,
          handleClear: this.handleQueryCleared,
          hideClearButton: !query,
          placeholder: placeholder,
          focus: focus,
          type: 'search',
          className: 'search-box',
          clearButtonSrText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_label_clear_search_text' }),
          inputTestId: 'search-bar-query' }),
        _react2.default.createElement(
          _baseButtons.PrimaryButton,
          {
            className: 'search-btn',
            handleClick: handleSearch,
            'data-test-id': 'search-button' },
          _react2.default.createElement(
            _baseScreenReaderMessage2.default,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_search' })
          ),
          _react2.default.createElement(_baseIcons.Search, { color: '' })
        )
      );
    }
  }]);

  return SearchBar;
}(_baseBcReactComponent2.default);

SearchBar.propTypes = {
  focus: _react.PropTypes.bool,
  placeholder: _react.PropTypes.string,
  query: _react.PropTypes.string.isRequired,

  handleChange: _react.PropTypes.func.isRequired,
  handleSearch: _react.PropTypes.func.isRequired
};

exports.default = SearchBar;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/search-bar/components/SearchBar.component.js
// module id = 1334
// module chunks = 0